import { makeStyles, styled } from "@material-ui/core/styles";

export const useStyles = makeStyles(() => ({
  switch: {
    display: "flex",
    alignItems: "center",
    padding: "0px 10px",
  },
}));
